<template>
  <div class="max-w-3xl">
    <h1
      v-if="title"
      class="theme-text-main font-bold font-title text-4xl lg:text-5xl text-left tracking-tight"
    >
      {{ title }}
    </h1>
    <div
      v-if="description"
      class="theme-text-neutral text-lg lg:text-xl mt-2 max-w-prose"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterEditorialTopCenterTitle',

  props: {
    description: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
